import { useEffect } from 'react';

type KeyBindings = {
  [key: string]: (event: KeyboardEvent) => void;
};

const useKeyBindings = (keyBindings: KeyBindings): void => {
  useEffect(() => {
    const pressedKeys = new Set<string>();

    const handleKeyDown = (event: KeyboardEvent) => {
      pressedKeys.add(event.key);
      const keys = Array.from(pressedKeys).sort().join('+');

      if (keyBindings[keys]) {
        event.preventDefault();
        keyBindings[keys](event);
      }
    };

    const handleKeyUp = (event: KeyboardEvent) => {
      pressedKeys.delete(event.key);
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [keyBindings]);
};

export default useKeyBindings;
